<template>
  <v-row class="d-flex justify-center">
    <v-card
      width="100%"
      max-width="550"
      style="min-height: 290px"
      v-for="(item, index) in cardPatForm2Items"
      :key="index"
    >
      <v-card-text class="pb-0">
        <p class="text-subtitle-1 primary--text mb-1">{{ item.subtitle }}</p>
        <v-divider inset class="ml-0 mb-5"></v-divider>
      </v-card-text>

      <v-form class="d-flex justify-start mx-7 pb-4">
        <v-row
          class="d-flex justify-start"
          v-if="modelFormReg1.usersPin === true"
        >
          <v-form-base :schema="schemaForm" :model="modelFormReg1" @input="handleEvents" />
          
          <v-col cols="12" class="d-flex justify-start pt-0 mt-0"></v-col>
          
          <v-col cols="6" sm="3" md="2" lg="1" class="d-flex justify-start pt-0 mt-n3">
            <v-dialog-pin :dialogPin="dialogAccountPin" />
          </v-col>
          
          <v-col cols="6" class="d-flex justify-end pt-0 mt-n3" v-if="modelFormReg1.usersPin === true">
            <v-btn color="primary" text medium @click="saveForm"> Guardar </v-btn>
          </v-col>
        </v-row>

        <v-row class="d-flex justify-start" v-else>
          <v-form-base :schema="schemaFormNoEdit" :model="modelFormReg1" @input="handleEvents" />
          <v-col cols="6" sm="3" md="2" lg="1" class="d-flex justify-start pt-0 mt-n3">
            <v-dialog-pin :dialogPin="dialogAccountPin" />
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </v-row>
</template>

<script>
import VFormBase from 'vuetify-form-base';
import VDialogPin from '@/components/base/VDialogPin.vue';

export default {
  components: {
    VFormBase,
    VDialogPin,
  },
  name: 'VCardProPatientBForm',
  props: [
    'cardPatForm2Items',
    'schemaForm',
    'schemaFormNoEdit',
    'modelFormReg1',
    'handleEvents',
    'saveForm',
    'dialogAccountPin',
  ],
  data() {
    return {};
  },
};
</script>

<style scoped>
.v-text-field--outlined fieldset {
  font-size: 90px;
}
</style>
